import {
  CrudOperation,
  type PermissionScopeOf,
} from '@gokrew/models/permissions';
import type { ApiResponse } from './generic';

/**
 * Permission subjects
 */
export enum Subject {
  DASHBOARD = 'dashboard',
  DESIGNATION = 'designation',
  DEPARTMENT = 'department',
  EMPLOYEE = 'employee',
  EMPLOYEE_EDUCATION = 'employee_education',
  EMPLOYEE_DOCUMENT = 'employee_document',
  COMPANY_DOCUMENT_TYPES = 'company_document_types',
  EMPLOYEE_FAMILY = 'employee_family',
  EMPLOYEE_ASSET = 'employee_asset',
  EMPLOYEE_SALARY = 'employee_salary',
  EMPLOYEE_SIN = 'employee_sin',
  EMPLOYEE_LEAVE = 'employee_leave',
  LEAVE_MANAGEMENT = 'leave_management',
  LEAVE_REQUEST = 'leave_request',
  ASSET = 'asset',
  ASSET_BRAND = 'asset_brand',
  ASSET_TYPES = 'asset_types',
  ACCESS = 'access',
  ROLE = 'company_role',
  BRANCH = 'branches',
  COMPANY = 'company',
  ASSET_MODEL = 'asset_model',
  ASSET_UNIT = 'asset_unit',
  VENDORS = 'vendors',
  FILE_MANAGEMENT = 'file_management',
  SLACK_BOT = 'slack_bot',
  TIMESHEET = 'timesheet',
  HR_NOTES = 'hr_notes',
  EMPLOYEE_NOTES = 'employee_notes',
  SURVEY = 'survey',
  ANNOUNCEMENT = 'announcement',
  BENEFIT = 'benefit',
  EMPLOYEE_BANK_ACCOUNT = 'employee_bank_account',
  TASK_MANAGEMENT = 'task_management',
  TEAMS_BOT = 'teams_bot',
  MCP_INTEGRATION = 'mcp_integration',
  PERFORMANCE_REVIEW = 'performance_review',
  RECRUITING = 'recruiting',
  REPORTING = 'reporting',
  BILLING = 'billing',
  ESIGNATURE = 'esignature',
  ANALYTICS = 'analytics',
  TRAINING = 'training',
  PAYROLL_EXPORT = 'payroll_export',
}

/**
 * Permission
 */
export type PermissionScope = PermissionScopeOf<Subject>;

/**
 * Map of permission keys
 */
export type SubjectOperationMap = {
  [S in Subject]: { [O in CrudOperation]: `${S}.${O}` };
};

/**
 * Permission scope api response
 */
export type PermissionScopeResp = ApiResponse<PermissionScope[]>;
